import { Groups, Language } from '@mui/icons-material';
import {
	HeartbeatIcon,
	HouseLineIcon,
	SyringeIcon,
	VideoCameraIcon,
} from '@phosphor-icons/react';
import {
	Accordion,
	ActiveLink,
	ListGroup,
	ListGroupItem as ListGroupsItem_old,
	NewspaperIcon,
	PencilSquare,
	PersonCircle,
	PersonLinesFill,
	SignInIcon,
} from 'components/ui';
import useLogout from 'hooks/useLogout';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { PersonFillLock, Tags } from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
const Group = styled(ListGroup)`
	font-weight: 400;
	color: var(--dunkelgrau);
	> a {
		text-decoration: none !important;
	}
	font-family: var(
		--default-font-family,
		ui-sans-serif,
		system-ui,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji',
		'Segoe UI Symbol',
		'Noto Color Emoji'
	);
`;

const ListGroupItem = styled(ListGroupsItem_old)`
	padding-right: 0;
`;

const SidebarAccordion = styled(Accordion)`
	.list-group-item {
		background: transparent;
		padding-left: 0;
	}

	.accordion-item {
		.accordion-header {
			.accordion-button {
				padding: 0;
				background-color: transparent;
			}
		}
		.accordion-collapse {
			background-color: transparent;
		}
	}
`;

function NavItems() {
	const [t] = useTranslation();
	const user = useSelector((state) => state.settings.currentUser);

	const getUserAreaLink = () => {
		if (user && !user.is_moderator && !user.is_admin) {
			return '/nutzerbereich';
		} else if (user && (user.is_moderator || user.is_admin)) {
			return '/adminbereich';
		} else {
			return '/';
		}
	};
	const logout = useLogout();
	return (
		<Group variant='flush' className='rounded-0'>
			{user && (
				<SidebarAccordion
					flush
					className='border-bottom overflow-hidden'
					alwaysOpen
				>
					<Accordion.Item eventKey='0'>
						<Accordion.Header>
							<ListGroupItem className='d-flex align-items-center cursor-pointer'>
								<PersonCircle size={20} />
								{user && !(user.is_moderator == 1 || user.is_admin == 1) && (
									<span className='ms-3'>{t('common.nutzerbereich')}</span>
								)}
								{user && (user.is_moderator == 1 || user.is_admin == 1) && (
									<span className='ms-3'>{t('common.adminbereich')}</span>
								)}
							</ListGroupItem>
						</Accordion.Header>
						<Accordion.Body className='py-0 ps-4 pe-0'>
							<ActiveLink href={getUserAreaLink()}>
								<ListGroupItem className='py-2 cursor-pointer'>
									<PencilSquare size={20} />
									<span className='ms-3'>
										{user &&
											user.is_moderator != 1 &&
											user.is_admin != 1 &&
											t('navigation.meine_eintraege')}
										{user &&
											(user.is_moderator == 1 || user.is_admin == 1) &&
											t('common.eintraege')}
									</span>
								</ListGroupItem>
							</ActiveLink>
							<ActiveLink href='/nutzerbereich/profil'>
								<ListGroupItem className='py-2 cursor-pointer'>
									<PersonLinesFill size={20} />
									<span className='ms-3'>{t('navigation.mein_profile')}</span>
								</ListGroupItem>
							</ActiveLink>
							<ActiveLink href='/startpage' onClick={logout}>
								<ListGroupItem className='py-2 cursor-pointer'>
									<SignInIcon />
									<span className='ms-3'>{t('navigation.abmelden')}</span>
								</ListGroupItem>
							</ActiveLink>
							{user && user.is_admin == 1 && (
								<ActiveLink href='/adminbereich/schlagworte'>
									<ListGroupItem className='py-2 cursor-pointer'>
										<Tags size={20} />
										<span className='ms-3'>{t('common.schlagworte')}</span>
									</ListGroupItem>
								</ActiveLink>
							)}
							{user &&
								(user.is_expert == 1 ||
									user.is_admin == 1 ||
									user.is_moderator == 1) && (
									<ActiveLink href='/adminbereich/arbeitsgruppen'>
										<ListGroupItem className='py-2 cursor-pointer'>
											<Groups size={20} />
											<span className='ms-3'>{t('common.arbeitsgruppen')}</span>
										</ListGroupItem>
									</ActiveLink>
								)}
							{user &&
								(user.is_moderator == 1 ||
									user.is_translator == 1 ||
									user.is_expert == 1 ||
									user.is_admin == 1) && (
									<ActiveLink href='/adminbereich/benutzerrechte'>
										<ListGroupItem className='py-2 cursor-pointer'>
											<PersonFillLock size={20} />
											<span className='ms-3'>{t('common.benutzerrechte')}</span>
										</ListGroupItem>
									</ActiveLink>
								)}
						</Accordion.Body>
					</Accordion.Item>
				</SidebarAccordion>
			)}
			{user && user.is_translator == 1 && (
				<ActiveLink href='/uebersetzung'>
					<ListGroupItem className='border-bottom px-0 cursor-pointer'>
						<Language />
						<span className='ms-3'>{t('common.uebersetzung')}</span>
					</ListGroupItem>
				</ActiveLink>
			)}
			{user && user.user_id == 1 && (
				<ActiveLink href='/test'>
					<ListGroupItem className='border-bottom px-0 cursor-pointer'>
						<HouseLineIcon size={24} weight='fill' />
						<span className='ms-3'>TEST</span>
					</ListGroupItem>
				</ActiveLink>
			)}
			<ActiveLink href={'/' + t('routing.startpage')}>
				<ListGroupItem className='border-bottom px-0 cursor-pointer'>
					<HouseLineIcon size={22} weight='fill' />
					<span className='ms-2'>{t('navigation.startseite')}</span>
				</ListGroupItem>
			</ActiveLink>
			<ActiveLink href={'/' + t('routing.impfschaden')}>
				<ListGroupItem className='border-bottom px-0 cursor-pointer '>
					<SyringeIcon size={22} weight='fill' />
					<span className='ms-2 ' style={{ fontWeight: 'bold' }}>
						Impfschäden
					</span>
				</ListGroupItem>
			</ActiveLink>
			<ActiveLink href='/mobilfunk'>
				<ListGroupItem className='border-bottom px-0 cursor-pointer'>
					<Image
						src={'/icons/categories/vetopedia_Icon_mobilfunk_v01.svg'}
						width={22}
						height={22}
						unoptimized
						alt=''
					/>
					<span className='ms-2'>Mobilfunkschäden</span>
				</ListGroupItem>
			</ActiveLink>
			<ActiveLink href={'https://v1.vetopedia.org/medienverleumdung'}>
				<ListGroupItem className='border-bottom px-0 cursor-pointer d-flex align-items-center'>
					<div>
						<HeartbeatIcon size={22} weight='fill' />
					</div>
					<div>
						<div className='ps-2'>Pharma- & Medizinopfer</div>
					</div>
				</ListGroupItem>
			</ActiveLink>
			<ActiveLink href={'https://v1.vetopedia.org/pharma'}>
				<ListGroupItem className='border-bottom px-0 cursor-pointer d-flex align-items-center'>
					<div>
						<VideoCameraIcon size={22} weight='fill' />
					</div>
					<div>
						<div className='ps-2'>Medien-Verleumdungen</div>
					</div>
				</ListGroupItem>
			</ActiveLink>
			<ActiveLink href={'/zensurkiosk'}>
				<ListGroupItem className='border-bottom px-0 cursor-pointer d-flex align-items-center'>
					<div>
						<NewspaperIcon size={22} weight='fill' />
					</div>
					<div>
						<div className='ps-2'>Zensur Kiosk</div>
					</div>
				</ListGroupItem>
			</ActiveLink>
		</Group>
	);
}

export default NavItems;
